import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';
type module = {
  name:string,
  description:string,
  icon:string,
  path:string,
}

type company = {
  name:string,
  modules:module[],
  icon:string,
  uid:string,
}

type TCompanyContext = {
  current:company,
  list: company[]
}
const defaultValues:TCompanyContext = {
  current: {name: '',modules:[],icon:"",uid:""},
  list: []
}
let updateCompanies = (newConf:any) => {}
const CompanyContext = createContext({companies:defaultValues,updateCompanies});

export const CompanyProvider = ({ children }:any) => {
  const [companies, setCompanies] = useState(defaultValues);
  const updateCompanies = useCallback((newConfig:any) => {
    setCompanies((prevConfig) => ({ ...prevConfig, ...newConfig }));
  }, []);

  const contextValue = useMemo(() => ({
    companies,
    updateCompanies,
  }), [companies, updateCompanies]);

  return (
    <CompanyContext.Provider value={contextValue}>
      {children}
    </CompanyContext.Provider>
  );
};

export const useCompany = () => {
  return useContext(CompanyContext);
};